export const regex = {
    // eslint-disable-next-line no-useless-escape
    latinCharacterRegex: /^(?! {2})[0-9a-zA-ZÀ-ɏ&'\-. ]*$/,
    // eslint-disable-next-line no-control-regex
    unicodeCharacterRegex: /^(?! {2})[\u0000-\uFFFF]*$/
};

const validFormat = (regexp, key) => ({
    validate: input => new RegExp(regexp).test(input),
    getErrorKeys: () => ({ errorMessageKey: key })
});

export const notEmpty = key => ({
    validate: input => !!input,
    getErrorKeys: () => ({ errorMessageKey: key })
});

export const lengthAtLeast = (length, key) => ({
    validate: input => input.length >= length,
    getErrorKeys: () => ({ errorMessageKey: key })
});

export const lengthAtMost = (length, key) => ({
    validate: input => input.length <= length,
    getErrorKeys: () => ({ errorMessageKey: key })
});

export const numberAtLeast = (minNum, key) => ({
    validate: input => input >= minNum,
    getErrorKeys: () => ({ errorMessageKey: key })
});

export const numberAtMost = (maxNum, key) => ({
    validate: input => input <= maxNum,
    getErrorKeys: () => ({ errorMessageKey: key })
});


export const isValidPropertyName = validFormat(regex.latinCharacterRegex, 'propertyName.regexError');
export const isValidUnicodePropertyName = validFormat(regex.unicodeCharacterRegex, 'propertyName.regexError');

export default {
    notEmpty,
    lengthAtLeast,
    lengthAtMost,
    numberAtLeast,
    numberAtMost,
    isValidPropertyName,
    isValidUnicodePropertyName,
    regex
};
